import React from 'react';
import ProductAutocomplete from './ProductAutocomplete';
import { useI18n } from './i18n';

// Product identification block of the Products sheet forms: name (with catalog suggestions), producer, origin,
// variety (not for vinegar) and harvest year. Props: category, values ({ product_name, producer, origin, variety,
// harvest_year }), onChange(patch) where patch holds the changed keys (several when a suggestion is picked).
function ProductFields({ category, values, onChange }) {
  const { t } = useI18n();
  const field = (name) => (e) => onChange({ [name]: e.target.value });
  return (
    <>
      <div className="form-field">
        <label>{t(`products.f.name.${category}`)} *</label>
        <ProductAutocomplete category={category} value={values.product_name} onChange={onChange} required />
      </div>
      <div className="form-field">
        <label>{t('products.f.producer')}</label>
        <input value={values.producer} onChange={field('producer')} maxLength={200} />
      </div>
      <div className="form-field">
        <label>{t('products.f.origin')}</label>
        <input value={values.origin} onChange={field('origin')} maxLength={200} />
      </div>
      {category !== 'vinegar' && (
        <div className="form-field">
          <label>{t(`products.f.variety.${category}`)}</label>
          <input value={values.variety} onChange={field('variety')} maxLength={200} />
        </div>
      )}
      <div className="form-field">
        <label>{t(`products.f.harvest_year.${category}`)}</label>
        <input type="number" min={1900} max={2200} value={values.harvest_year} onChange={field('harvest_year')} />
      </div>
    </>
  );
}

export default ProductFields;
